import { ListItem } from '@uplift/types';
import { restClient } from '../client';

export type GetLanguagesResponse = {
  data: ListItem[];
};

export const getLanguages = () =>
  restClient.request<GetLanguagesResponse>('/api/v1/languages');
